import { render, staticRenderFns } from "./PersonalAccount.vue?vue&type=template&id=937670f2&scoped=true"
import script from "./PersonalAccount.vue?vue&type=script&lang=js"
export * from "./PersonalAccount.vue?vue&type=script&lang=js"
import style0 from "./PersonalAccount.vue?vue&type=style&index=0&id=937670f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937670f2",
  null
  
)

export default component.exports